export default function SelectPill({
  label,
  value,
  onChange,
  options
}) {
  // F-04: Find the currently selected option's label to display
  const selectedOption = options.find((opt) => opt.value === value);
  const selectedLabel = selectedOption ? selectedOption.label : "";

  return (
    <div className="filter-pill">
      <span className="filter-label">{label}:</span>
      <span className="filter-value">{selectedLabel}</span>
      <select value={value} onChange={onChange}>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
